import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";

import { socialLogin } from "app/api/busha";
import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";

export default function useSocialLogin() {
  const { isLoading, data, mutate } = useMutation(socialLogin, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      toast.error(errorMessage);
    },
  });

  return { isLoading, data: data?.data, login: mutate };
}
